import styled from "styled-components";

export const DeviceModel3DWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

